import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
`;

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
`;

export const PaginationWrapper = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 100;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  border-top: 1px solid ${(props) => props.theme?.colors?.greySix || "rgba(0,0,0,0.04)"};
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

